var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"372e9c57e5178ec2db629f9bbcd00865db45a80a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["noundles-nextjs@noundles"]={id:"372e9c57e5178ec2db629f9bbcd00865db45a80a"};
      